/** Match `landing.css` — HD art loads only from this width up (saves mobile bandwidth). */
export const LAND_HD_MEDIA = "(min-width: 1024px)";

/** Narrow viewports: default gameplay tab, carousel touch-drag, etc. */
export const LANDING_MOBILE_UX_MQ = "(max-width: 899px)";

/** Wide landing layout — gallery strip width, faction alignment, context-menu guard, etc. */
export const LANDING_DESKTOP_UX_MQ = "(min-width: 900px)";
